import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ps-tag-filter" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass({ active: _ctx.selectedTags.length === 0 }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
    }, " All ", 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTags, (tag) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tag,
        class: _normalizeClass({ active: _ctx.selectedTags.includes(tag) }),
        onClick: ($event: any) => (_ctx.toggleTag(tag))
      }, _toDisplayString(tag), 11, _hoisted_2))
    }), 128))
  ]))
}